// Corte 6 (G3) — singleton de audio de alerta.
// Desbloqueo: (1) en el MISMO gesto del permiso de notificaciones (enablePush),
// (2) fallback: primer pointerdown de la página, (3) resume en visibilitychange.
// Síntesis Web Audio (sin asset) — migrado desde el playDing de OwnerInbox.

let ctx = null;
let unlocked = false;
let listenersInstalled = false;

// A6 — config global editable en admin (/api/audio-config)
let audioCfg = { in_app_sound_enabled: true, volume_normal_pct: 100, volume_emergency_pct: 100 };
let cfgLoaded = false;

export function loadAudioConfig() {
  if (cfgLoaded) return;
  cfgLoaded = true;
  try {
    const API = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${API}/api/audio-config`)
      .then((r) => (r.ok ? r.json() : null))
      .then((cfg) => { if (cfg && typeof cfg === "object") audioCfg = { ...audioCfg, ...cfg }; })
      .catch(() => {});
  } catch (_) { /* noop */ }
}

function ensureCtx() {
  if (ctx) return ctx;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  ctx = new AC();
  return ctx;
}

export function unlockAudio() {
  // Llamar DENTRO de un gesto del usuario (click/tap). Idempotente.
  try {
    const c = ensureCtx();
    if (!c) return false;
    if (c.state === "suspended") c.resume();
    // buffer de ganancia 0 → marca el contexto como "tocado por gesto" (iOS)
    const buf = c.createBuffer(1, 1, 22050);
    const src = c.createBufferSource();
    src.buffer = buf;
    src.connect(c.destination);
    src.start(0);
    unlocked = true;
    return true;
  } catch (_) {
    return false;
  }
}

export function installAudioUnlockListeners() {
  if (listenersInstalled) return;
  listenersInstalled = true;
  const onFirstPointer = () => {
    unlockAudio();
    window.removeEventListener("pointerdown", onFirstPointer);
  };
  window.addEventListener("pointerdown", onFirstPointer, { passive: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && ctx && ctx.state === "suspended") {
      try { ctx.resume(); } catch (_) {}
    }
  });
}

export function playAlertSound(isEmergency = false) {
  try {
    if (!audioCfg.in_app_sound_enabled) return false;
    const volMult = (isEmergency ? audioCfg.volume_emergency_pct : audioCfg.volume_normal_pct) / 100;
    if (volMult <= 0) return false;
    const c = ensureCtx();
    if (!c) return false;
    if (c.state === "suspended") {
      try { c.resume(); } catch (_) {}
    }
    const now = c.currentTime;
    const play = (freq, start, dur, gain = 0.08) => {
      const osc = c.createOscillator();
      const g = c.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      const gv = gain * volMult;
      g.gain.setValueAtTime(0, now + start);
      g.gain.linearRampToValueAtTime(gv, now + start + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(g);
      g.connect(c.destination);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.02);
    };
    if (isEmergency) {
      play(880, 0.0, 0.18, 0.11);
      play(659, 0.22, 0.18, 0.11);
      play(880, 0.44, 0.28, 0.12);
    } else {
      play(740, 0.0, 0.16, 0.08);
      play(988, 0.18, 0.22, 0.08);
    }
    return true;
  } catch (_) {
    return false;
  }
}

export function isAudioUnlocked() {
  return unlocked && ctx && ctx.state === "running";
}
